<template>
  <div>
    <v-container fluid>
      <v-toolbar :image="SubNavbarBackGround" dark class="header-title">
          <v-toolbar-title  class="title" :style="'color: #' + FontColorTitle">Upload Sound To Document</v-toolbar-title>
          <v-spacer />
          <div class="d-flex pr-4">
            <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{ today }}</v-toolbar-title>
          </div>
      </v-toolbar>
      <v-card class="card2" style="margin-top: 1rem">
        <div class="header-section">
          <!-- Document Name Showcase -->
          <div class="document-showcase">
            <div class="document-header">
              <div class="document-icon">
                <v-icon color="white" size="32">mdi-file-document</v-icon>
              </div>
              <div class="document-info">
                <span class="document-label">Current Document</span>
                <h2 class="document-name">
                  {{ documentName || "No Document Selected" }}
                </h2>
              </div>
            </div>
          </div>

          <!-- Controls Row -->
          <div class="controls-row">
            <div class="toggle-section">
              <v-switch
                v-model="CheckboxShowAllText"
                color="primary"
                hide-details
                density="compact"
                inset
                class="compact-toggle"
              >
                <template #label>
                  <div class="toggle-label">
                    <v-icon
                      size="20"
                      class="mr-1"
                      :color="CheckboxShowAllText ? 'primary' : 'grey'"
                    >
                      mdi-text-long
                    </v-icon>
                    <span style="font-size: 1rem">{{
                      $t("_ShowAllText")
                    }}</span>
                  </div>
                </template>
              </v-switch>
            </div>

            <v-btn
              v-if="canAdd"
              id="button-add-uploadsoundtodocumentdetail"
              color="success"
              variant="flat"
              @click="Add()"
              class="add-btn-green"
            >
              <v-icon start size="18">mdi-plus</v-icon>
              {{ $t("add") }}
            </v-btn>
          </div>
        </div>
        <v-flex class="flex">
          <v-data-table-server
            v-model:options="options"
            :items-per-page="options.itemsPerPage"
            :loading="loading"
            :items-length="speechDocumentDataDetail.total"
            :items="speechDocumentDataDetail.data"
            :headers="headers"
          >
            <template v-slot:item="{ item }">
              <tr class="table-row">
                <td class="number-cell">
                  {{ item.number }}
                </td>

                <td class="text-cell">
                  <div class="text-container">
                    <div class="text-content-wrapper">
                      <span
                        :class="[
                          item.show ? 'text-content-show' : 'text-content',
                        ]"
                        v-html="formatText(item.originalText)"
                      ></span>
                    </div>
                  </div>
                </td>

                <td class="text-cell">
                  <div class="text-container">
                    <div class="text-content-wrapper">
                      <span
                        :class="[
                          item.show ? 'text-content-show' : 'text-content',
                        ]"
                        v-html="formatText(item.summarizedText)"
                        :style="getStyle(item.summarizedText)"
                      ></span>
                    </div>
                    <v-btn
                      icon
                      variant="text"
                      size="small"
                      color="primary"
                      @click="item.show = !item.show"
                      class="expand-btn"
                    >
                      <v-icon
                        size="20"
                        color="primary"
                        :color="item.show ? 'primary' : 'grey'"
                      >
                        {{ item.show ? "mdi-chevron-up" : "mdi-chevron-down" }}
                      </v-icon>
                      <v-tooltip activator="parent" location="top">
                        {{ item.show ? "Collapse" : "Expand" }}
                      </v-tooltip>
                    </v-btn>
                  </div>
                </td>

                <td class="action-cell">
                  <div class="action-container">
                    <div class="action-group">
                      <!-- Edit Button -->
                      <v-btn
                        id="button-edit-popupedit-uploadsoundtodocumentdetail"
                        variant="text"
                        density="comfortable"
                        @click="EditSpeechDocumentDetail(item)"
                        class="action-btn edit-btn"
                        icon
                        size="small"
                      >
                        <v-icon size="18">{{ canEdit ? 'mdi-pencil-outline' : 'mdi-eye-outline' }}</v-icon>
                        <v-tooltip activator="parent" location="top"
                          >{{ canEdit ? 'Edit' : 'View' }}</v-tooltip
                        >
                      </v-btn>

                      <!-- Import Button -->
                      <v-btn
                        v-if="canEdit"
                        id="button-importdocument-popupimportdocument-uploadsoundtodocumentdetail"
                        variant="text"
                        density="comfortable"
                        @click="ImportDocument(item)"
                        class="action-btn download-btn"
                        icon
                        size="small"
                      >
                        <v-icon size="18">mdi-database-import-outline</v-icon>
                        <v-tooltip activator="parent" location="top"
                          >Import to Knowledge Base</v-tooltip
                        >
                      </v-btn>

                      <!-- Summarize Button -->
                      <v-btn
                        v-if="canEdit"
                        id="button-summarized-popupsummarized-uploadsoundtodocumentdetail"
                        variant="text"
                        density="comfortable"
                        @click="SummarizedPopup(item)"
                        class="action-btn summarize-btn"
                        icon
                        size="small"
                      >
                        <v-icon size="18">mdi-auto-fix</v-icon>
                        <v-tooltip activator="parent" location="top">
                          Summarize with AI Model
                        </v-tooltip>
                      </v-btn>

                      <!-- Action Divider -->
                      <div v-if="canEdit || canDelete" class="action-divider"></div>

                      <!-- Delete Button -->
                      <v-btn
                        v-if="canDelete"
                        id="button-delete-uploadsoundtodocumentdetail"
                        variant="text"
                        density="comfortable"
                        @click="DeleteById(item.id)"
                        class="action-btn delete-btn"
                        icon
                        size="small"
                      >
                        <v-icon size="18">mdi-delete-outline</v-icon>
                        <v-tooltip activator="parent" location="top"
                          >Delete</v-tooltip
                        >
                      </v-btn>
                    </div>
                  </div>
                </td>
              </tr>
            </template>
          </v-data-table-server>
        </v-flex>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            id="button-close-uploadsoundtodocumentdetail"
            class="white--text mt-3"
            style="
              margin-right: 2em;
              margin-bottom: 2em;
              border-radius: 25.342px;
              background: #faa91b;
              width: 89.863px;
            "
            to="/UploadSoundToDocument"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-container>

    <!--Upload popup-->
    <v-container fluid>
      <v-dialog
        v-model="uploadDialog"
        max-width="900px"
        persistent
        transition="dialog-bottom-transition"
        class="modern-dialog"
      >
        <v-card class="dialog-card">
          <!-- Dialog Header -->
          <v-card-title class="dialog-header dialog-header-add">
            <div class="header-main">
              <div class="header-icon-container">
                <div class="icon-background">
                  <v-icon color="white" size="28">mdi-cloud-upload</v-icon>
                </div>
              </div>
              <div class="header-text-content">
                <h2 class="dialog-title">Upload Speech Files</h2>
                <p class="dialog-subtitle">
                  Upload and process audio files for transcription
                </p>
              </div>
            </div>
            <div class="header-actions">
              <v-btn
                icon
                variant="text"
                color="white"
                @click="uploadDialog = false"
                class="close-btn"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div>
          </v-card-title>

          <v-divider></v-divider>

          <!-- Dialog Content -->
          <v-card-text class="dialog-content">
            <!-- Document Name and Language Row -->
            <v-row>
              <v-col cols="12" md="8">
                <div class="input-group">
                  <label class="input-label">Document Name *</label>
                  <v-text-field
                    v-model="documentName"
                    :rules="[rules.required]"
                    required
                    variant="outlined"
                    disabled
                    hide-details="auto"
                    class="modern-input"
                  >
                    <template #prepend-inner>
                      <v-icon color="primary" size="20"
                        >mdi-file-document-outline</v-icon
                      >
                    </template>
                  </v-text-field>
                </div>
              </v-col>
              <v-col cols="12" md="4">
                <div class="input-group">
                  <label class="input-label">Language</label>
                  <v-select
                    id="language-autocomplete-uploadsoundtodocumentdetail"
                    :items="langaugeType"
                    item-title="name"
                    item-value="value"
                    v-model="request.langPop"
                    variant="outlined"
                    hide-details
                    class="modern-input"
                  >
                    <template #prepend-inner>
                      <v-icon color="primary" size="20">mdi-translate</v-icon>
                    </template>
                  </v-select>
                </div>
              </v-col>
            </v-row>

            <!-- AI Model and Bot Summation Row -->
            <v-row class="mb-2">
              <v-col cols="12" md="8">
                <div class="input-group">
                  <label class="input-label">AI Model (for summation)</label>
                  <v-select
                    :items="listDDModelDisplayName"
                    :item-title="getItemModelNameText"
                    :item-value="getItemModelNameID"
                    :disabled="!botSummation"
                    v-model="modelDisplayID"
                    variant="outlined"
                    clearable
                    hide-details
                    placeholder="Select AI model for text summation"
                    class="modern-input"
                    :class="{ 'input-disabled': !botSummation }"
                    :rules="[v => !!v || 'Required.']"
                  >
                    <template #prepend-inner>
                      <v-icon color="primary" size="20"
                        >mdi-robot-outline</v-icon
                      >
                    </template>
                  </v-select>
                </div>
              </v-col>
              <v-col cols="12" md="4" class="d-flex align-center">
                <v-switch
                  id="botsummation-checkbox-uploadsoundtodocumentdetail"
                  v-model="botSummation"
                  color="primary"
                  hide-details
                  density="compact"
                  inset
                  class="inline-switch"
                >
                  <template #label>
                    <div class="inline-label">
                      <span class="mr-2">Bot Summation</span>
                      <v-icon
                        size="20"
                        :color="botSummation ? 'primary' : 'grey'"
                      >
                        mdi-file-document-edit-outline
                      </v-icon>
                    </div>
                  </template>
                </v-switch>
              </v-col>
            </v-row>

            <!-- File Upload Area -->
            <div class="upload-section">
              <div class="upload-header">
                <v-icon color="primary" class="mr-2"
                  >mdi-cloud-upload-outline</v-icon
                >
                <span class="upload-title">Upload Audio Files</span>
              </div>

              <v-card
                variant="outlined"
                class="upload-area-card"
                :class="{ 'drag-over': isDragOver }"
              >
                <MultipleDragAndDrop
                  :dialog.sync="uploadDialog"
                  :multiple="true"
                  @filesUploaded="processUpload($event)"
                  @dragover="isDragOver = true"
                  @dragleave="isDragOver = false"
                  @drop="isDragOver = false"
                />
              </v-card>

              <div class="upload-help-text">
                <v-icon size="16" color="grey" class="mr-1"
                  >mdi-information-outline</v-icon
                >
                <span
                  >Supported formats: MP3, WAV, M4A, FLAC (Max size: 100MB per
                  file)</span
                >
              </div>
            </div>
          </v-card-text>

          <v-divider></v-divider>

          <!-- Dialog Actions -->
          <v-card-actions class="dialog-actions">
            <div class="actions-content">
              <div class="actions-left">
                <div class="actions-left">
                  <v-chip
                    v-if="request.filesList && request.filesList.length > 0"
                    color="success"
                    variant="tonal"
                    size="small"
                  >
                    <v-icon start size="16">mdi-file-multiple</v-icon>
                    {{ request.filesList.length }} file(s) selected
                  </v-chip>
                </div>
              </div>
              <div class="actions-right">
                <v-btn
                  variant="outlined"
                  color="grey"
                  @click="uploadDialog = false"
                  class="dialog-action-btn cancel-btn"
                >
                  <v-icon start size="18">mdi-close</v-icon>
                  Cancel
                </v-btn>

                <v-btn
                  v-if="canAdd"
                  id="button-save-popupupload-uploadsoundtodocumentdetail"
                  variant="flat"
                  @click="Save()"
                  :loading="loading"
                  class="dialog-action-btn save-btn-add"
                  :disabled="!documentName || !request.filesList"
                >
                  <v-icon start size="18">mdi-upload</v-icon>
                  Upload Files
                </v-btn>
              </div>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
    <!--Edit popup-->
    <v-container fluid>
      <v-dialog
        v-model="editDialog"
        max-width="900px"
        persistent
        transition="dialog-bottom-transition"
        class="modern-dialog"
      >
        <v-card class="dialog-card">
          <!-- Dialog Header -->
          <v-card-title class="dialog-header dialog-header-edit">
            <div class="header-main">
              <div class="header-icon-container">
                <div class="icon-background">
                  <v-icon color="white" size="28">{{ canEdit ? 'mdi-pencil-outline' : 'mdi-eye-outline' }}</v-icon>
                </div>
              </div>
              <div class="header-text-content">
                <h2 class="dialog-title">{{ canEdit ? 'Edit Text Summarization' : 'View Text Summarization' }}</h2>
                <p class="dialog-subtitle">
                  {{ canEdit ? 'Edit original and summarized text content' : 'View original and summarized text content' }}
                </p>
              </div>
            </div>
            <div class="header-actions">
              <v-btn
                icon
                variant="text"
                color="white"
                @click="editDialog = false"
                class="close-btn"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div>
          </v-card-title>

          <v-divider></v-divider>

          <!-- Dialog Content -->
          <v-card-text class="dialog-content">
            <v-row class="mb-4">
              <v-col cols="12" md="6">
                <div class="input-group">
                  <label class="input-label">Original Text *</label>
                  <v-textarea
                    v-model="edit.originalText"
                    id="originaltext-textarea-edit-uploadsoundtodocumentdetail"
                    variant="outlined"
                    rows="8"
                    hide-details="auto"
                    class="modern-input"
                  >
                    <template #prepend-inner>
                      <v-icon color="primary" size="20">mdi-text</v-icon>
                    </template>
                  </v-textarea>
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <div class="input-group">
                  <label class="input-label">Summarized Text</label>
                  <v-textarea
                    v-model="edit.summarizedText"
                    id="summarizedtext-textarea-edit-uploadsoundtodocumentdetail"
                    variant="outlined"
                    rows="8"
                    hide-details="auto"
                    class="modern-input"
                  >
                    <template #prepend-inner>
                      <v-icon color="primary" size="20">mdi-text-short</v-icon>
                    </template>
                  </v-textarea>
                </div>
              </v-col>
            </v-row>
          </v-card-text>

          <v-divider></v-divider>

          <!-- Dialog Actions -->
          <v-card-actions class="dialog-actions">
            <div class="actions-content">
              <div class="actions-left"></div>
              <div class="actions-right">
                <v-btn
                  variant="outlined"
                  color="grey"
                  @click="editDialog = false"
                  class="dialog-action-btn cancel-btn"
                >
                  <v-icon start size="18">mdi-close</v-icon>
                  Cancel
                </v-btn>

                <v-btn
                  v-if="canEdit"
                  id="button-editsave-popupedit-uploadsoundtodocumentdetail"
                  variant="flat"
                  @click="EditSave()"
                  class="dialog-action-btn save-btn-edit"
                >
                  <v-icon start size="18">mdi-content-save</v-icon>
                  Save Changes
                </v-btn>
              </div>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>

    <!--Import popup-->
    <v-container fluid>
      <v-dialog
        v-model="importDocPopup"
        max-width="700px"
        persistent
        transition="dialog-bottom-transition"
        class="modern-dialog"
      >
        <v-card class="dialog-card">
          <!-- Dialog Header -->
          <div class="dialog-header dialog-header-edit">
            <div class="header-main">
              <div class="header-icon-container">
                <div class="icon-background">
                  <v-icon color="white" size="28">mdi-database-import</v-icon>
                </div>
              </div>
              <div class="header-text-content">
                <h2 class="dialog-title">Import To Knowledge Document</h2>
                <p class="dialog-subtitle">
                  Import processed content to knowledge base
                </p>
              </div>
            </div>
            <div class="header-actions">
              <v-btn
                icon
                variant="text"
                color="white"
                @click="importDocPopup = false"
                class="close-btn"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div>
          </div>

          <v-divider></v-divider>

          <!-- Dialog Content -->
          <v-card-text class="dialog-content">
            <v-row class="mb-4">
              <v-col cols="12" md="8">
                <div class="input-group">
                  <label class="input-label">Select Document *</label>
                  <v-select
                    id="docname-autocomplete-popupimport-uploadsoundtodocumentdetail"
                    :items="listDDLVector"
                    :item-title="getDocName"
                    :item-value="getDocId"
                    v-model="DocId"
                    :rules="[rules.required]"
                    variant="outlined"
                    clearable
                    hide-details="auto"
                    placeholder="Choose a knowledge document"
                    class="modern-input"
                  >
                    <template #prepend-inner>
                      <v-icon color="primary" size="20">mdi-database</v-icon>
                    </template>
                  </v-select>
                </div>
              </v-col>
              <v-col cols="12" md="4">
                <div class="input-group">
                  <label class="input-label">Max Split Characters *</label>
                  <v-text-field
                    v-model="maxLimitedCharacter"
                    type="number"
                    placeholder="5000"
                    clearable
                    :rules="[rules.required]"
                    variant="outlined"
                    hide-details="auto"
                    class="modern-input"
                  >
                    <template #prepend-inner>
                      <v-icon color="primary" size="20">mdi-format-text</v-icon>
                    </template>
                  </v-text-field>
                </div>
              </v-col>
            </v-row>

            <div class="info-card">
              <v-icon color="info" class="mr-2">mdi-information</v-icon>
              <div>
                <strong>Import Information:</strong><br />
                This will process and split the content for knowledge base
                integration.
              </div>
            </div>
          </v-card-text>

          <v-divider></v-divider>

          <!-- Dialog Actions -->
          <v-card-actions class="dialog-actions">
            <div class="actions-content">
              <div class="actions-left"></div>
              <div class="actions-right">
                <v-btn
                  variant="outlined"
                  color="grey"
                  @click="importDocPopup = false"
                  class="dialog-action-btn cancel-btn"
                >
                  <v-icon start size="18">mdi-close</v-icon>
                  Cancel
                </v-btn>
                <v-btn
                  id="button-upload-popupimport-uploadsoundtodocumentdetail"
                  variant="flat"
                  @click="SaveImport"
                  :loading="loading"
                  class="dialog-action-btn save-btn-edit"
                  :disabled="!DocId || !maxLimitedCharacter"
                >
                  <v-icon start size="18">mdi-import</v-icon>
                  Import
                </v-btn>
              </div>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
    <!--Summarized popup-->
    <v-container fluid>
      <v-dialog
        v-model="SummarizedPreparePopup"
        max-width="600px"
        persistent
        transition="dialog-bottom-transition"
        class="modern-dialog"
      >
        <v-card class="dialog-card">
          <!-- Dialog Header -->
          <v-card-title class="dialog-header dialog-header-edit">
            <div class="header-main">
              <div class="header-icon-container">
                <div class="icon-background">
                  <v-icon color="white" size="28">mdi-auto-fix</v-icon>
                </div>
              </div>
              <div class="header-text-content">
                <h2 class="dialog-title">Summarize Text</h2>
                <p class="dialog-subtitle">Generate AI-powered text summary</p>
              </div>
            </div>
            <div class="header-actions">
              <v-btn
                icon
                variant="text"
                color="white"
                @click="SummarizedPreparePopup = false"
                class="close-button"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div>
          </v-card-title>

          <v-divider></v-divider>

          <!-- Dialog Content -->
          <v-card-text class="dialog-content">
            <div class="input-group">
              <label class="input-label">AI Model for Summarization *</label>
              <v-select
                id="summarizedtext-autocomplete-uploadsoundtodocumentdetail"
                :items="listDDModelDisplayName"
                :item-title="getItemModelNameText"
                :item-value="getItemModelNameID"
                :rules="[rules.required]"
                v-model="SummarizedRow.modelDisplayID"
                variant="outlined"
                clearable
                hide-details="auto"
                placeholder="Choose an AI model"
                class="modern-input"
              >
                <template #prepend-inner>
                  <v-icon color="primary" size="20">mdi-robot-outline</v-icon>
                </template>
              </v-select>
            </div>

            <div class="info-card mt-4">
              <v-icon color="info" class="mr-2">mdi-information</v-icon>
              <div>
                <strong>Summarization Process:</strong><br />
                The selected AI model will analyze and create a concise summary
                of the original text.
              </div>
            </div>
          </v-card-text>

          <v-divider></v-divider>

          <!-- Dialog Actions -->
          <div class="dialog-actions">
            <div class="actions-content">
              <div class="actions-left"></div>
              <div class="actions-right">
                <v-btn
                  variant="outlined"
                  color="grey"
                  @click="SummarizedPreparePopup = false"
                  class="cancel-btn dialog-action-btn"
                >
                  <v-icon start size="18">mdi-close</v-icon>
                  Cancel
                </v-btn>

                <v-btn
                  id="button-summarized-uploadsoundtodocumentdetail"
                  variant="flat"
                  @click="SummarizedDetail()"
                  :loading="loading"
                  class="dialog-action-btn save-btn-edit"
                  :disabled="!SummarizedRow.modelDisplayID"
                >
                  <v-icon start size="18">mdi-auto-fix</v-icon>
                  Generate Summary
                </v-btn>
              </div>
            </div>
          </div>
        </v-card>
      </v-dialog>
    </v-container>
    <!--Loading bar-->>
    <v-overlay :value="loading">
      <v-card color="#1976D2" dark>
        <v-card-text class="white--text">
          Loading Please Wait...
          <v-progress-linear
            indeterminate
            color="#FAA91B"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-overlay>
  </div>
</template>
<script>
import MultipleDragAndDrop from "@/components/MultipleDragAndDrop.vue";
import editImg from "@/assets/edit1.png";
import deleteImg from "@/assets/delete1.png";
export default {
  name: "UploadSoundToDocumentDetail",
  components: { MultipleDragAndDrop },
  computed: {
    isViewOnly() {
      return this.$pagePermission && this.$pagePermission.isViewOnly('UploadSoundToDocumentDetail');
    },
    canAdd() {
      return !!(this.$pagePermission && this.$pagePermission.canAdd('UploadSoundToDocumentDetail'));
    },
    canEdit() {
      return !!(this.$pagePermission && this.$pagePermission.canEdit('UploadSoundToDocumentDetail'));
    },
    canDelete() {
      return !!(this.$pagePermission && this.$pagePermission.canDelete('UploadSoundToDocumentDetail'));
    },
    documentId() {
      return this.$route.query.id || "";
    },
  },
  inject:[
    "FontColorTitle",
    "SubNavbarBackGround",
  ],
  data() {
    return {
      allowOptionWatch: false,
      uploadDialog: false,
      editDialog: false,
      itemsPerPage: 10,
      dataName: "",
      documentName: "",
      ShowAllText: false,
      CheckboxShowAllText: false,
      today: null,
      searchDocName: "",
      langauge: ["TH", "EN"],
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [],
      },
      Axios_ControllerAduio: null,
      loading: false,
      modelDisplayID: 0,
      DocId: 0,
      maxLimitedCharacter: 5000,
      importDocPopup: false,
      queryImport: 0,
      ImportData: "",
      listDDLVector: [],
      SummarizedPreparePopup: false,
      langaugeType: [
        { name: "TH", value: "th-TH" },
        { name: "EN", value: "en-US" },
      ],
      listDDModelDisplayName: [],
      modelDisplay: null,
      botSummation: false,
      images: {
        edit: editImg,
        delete: deleteImg,
      },
      rules: {
        required: (value) => !!value || "Required.",
      },
      request: {
        dataName: "",
        filesList: [],
        langPop: "th-TH",
      },
      LangPop: "th-TH",
      speechDocumentDataDetail: {
        total: 0,
        sortDesc: false,
        sortBy: false,
        data: [],
      },
      speechDocumentData: {
        total: 0,
        sortDesc: false,
        sortBy: false,
        data: [],
      },
      edit: {
        id: 0,
        originalText: "",
        summarizedText: "",
      },
      SummarizedRow: {
        id: 0,
        originalText: null,
        summarizedText: null,
        modelDisplayID: 0,
      },
      headers: [
        {
          title: "No.",
          align: "center",
          value: "number",
          sortable: false,
          width: "10%",
        },
        {
          title: "Original text",
          align: "center",
          value: "originalText",
          sortable: false,
          width: "40%",
        },
        {
          title: "Summarized text",
          align: "center",
          value: "summarizedText",
          sortable: false,
          width: "40%",
        },
        { title: "Action", align: "center", sortable: false, width: "10%" },
      ],
    };
  },
  watch: {
    options: {
      handler() {
        if (this.allowOptionWatch) {
          this.GetSpeechDocumentDetail();
        }
      },
      deep: true,
    },
    CheckboxShowAllText(newVal) {
      let self = this;
      if (newVal) {
        self.ShowAll();
      } else {
        self.CloseShowAll();
      }
    },
  },
  methods: {
    ShowAll() {
      let self = this;
      self.ShowAllText = !self.ShowAllText;
      self.speechDocumentDataDetail.data.forEach((element) => {
        element.show = self.ShowAllText;
      });
    },
    CloseShowAll() {
      let self = this;
      self.ShowAllText = !self.ShowAllText;
      self.speechDocumentDataDetail.data.forEach((element) => {
        element.show = self.ShowAllText;
      });
    },
    GetDate() {
      let today1 = new Date();
      let dd = today1.getDate();
      let mm = today1.getMonth() + 1; // January is 0!

      let yyyy = today1.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }

      this.today = dd + "/" + mm + "/" + yyyy;
    },
    Add() {
      this.uploadDialog = true;
    },
    processUpload(files) {
      let self = this;
      var validFiles = [];
      for (const file of files) {
        validFiles.push(file);
      }
      self.request.filesList = validFiles;
    },
    ImportDocument(item) {
      this.importDocPopup = true;
      this.ImportData =
        item.summarizedText == "-" ? item.originalText : item.summarizedText;
    },
    Save() {
      let self = this;
      if (!self.documentId) {
        alert("Please Fill All The Fields!");
        return;
      }

      if (!self.request.filesList) {
        alert("Please Add some file!");
        return;
      }
      let formData = new FormData();
      self.request.dataName = self.documentId;
      self.Axios_ControllerAduio = new AbortController();

      let Config = {
        signal: self.Axios_ControllerAduio.signal,
      };

      self.request.filesList.forEach((file) => {
        formData.append(`FileSpeech`, file);
      });

      formData.append("LangPop", self.request.langPop);
      formData.append("dataName", self.request.dataName);
      formData.append("FileSpeech", self.request.filesList);
      if (self.modelDisplayID != 0 && self.botSummation == true) {
        formData.append("modelDisplay", self.modelDisplayID);
      }
      self.loading = true;
      try {
        self.$call.UploadSpeechDocument(
          formData,
          Config,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              self.$swal.fire({
                icon: "success",
                title: dataResponse.message,
                showConfirmButton: false,
                timer: 1500,
                backdrop: false
              });
              self.loading = false;
              self.uploadDialog = false;
              self.GetSpeechDocumentTable();
              self.GetSpeechDocumentDetail();
            }
          },
          (errorResource) => {
            self.loading = false;
            console.error(errorResource);
          }
        );
      } catch (error) {
        self.LogTrace(error, "Save");
      }
    },
    SaveImport() {
      let self = this;
      let temp = {
        vectordbName: self.DocId,
        modelType: 1,
        groupReplaceID: null,
        Content: self.ImportData,
        flagNew: false,
        customCharacter: null,
        DetectLanguage: true,
        MaxLimitedCharacter: self.maxLimitedCharacter,
      };
      self.dialog = true;
      try {
        self.$call.SaveAddVector(
          temp,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              self.$swal.fire({
                icon: "success",
                title: dataResponse.message,
                showConfirmButton: false,
                timer: 1500,
              });
              self.importDocPopup = false;
            }
          },
          (errorResource) => {
            self.dialog = false;
            console.error(errorResource);
          }
        );
      } catch (error) {
        this.LogTrace(error, "DeleteGroup");
      }
    },
    GetSpeechDocumentDetail() {
      let self = this;
      self.loading = true;
      if (self.isSearch) {
        self.options.page = 1;
        self.options.itemsPerPage = 10;
      }

      let { page, itemsPerPage } = self.options;
      self.sortBy =
        self.options.sortBy == undefined || self.options.sortBy.length == 0
          ? null
          : self.options.sortBy[0];
      self.sortDesc =
        self.options.sortDesc == undefined || self.options.sortDesc.length == 0
          ? null
          : self.options.sortDesc[0];

      var tempData = {
        page: page,
        perPage: itemsPerPage != -1 ? itemsPerPage : self.totalTable,
        id: self.documentId,
        sortBy: self.sortBy,
        sortDesc: self.sortDesc,
      };
      self.$call.GetSpeechDocumentDetail(
        tempData,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.speechDocumentDataDetail.data = dataResponse.data.data;
            self.documentName = dataResponse.data.documentName;
            if (self.speechDocumentDataDetail.data != 0) {
              self.speechDocumentDataDetail.total = dataResponse.data.total;
              self.speechDocumentDataDetail.data.forEach((item) => {
                item.summarizedText =
                  item.summarizedText == null || item.summarizedText == ""
                    ? "-"
                    : item.summarizedText;
                item.show = self.ShowAllText;
              });
              self.AutoRefresh();
            }
            self.loading = false;
          }
        },
        (errorResource) => {
          self.loading = false;
          console.error(errorResource);
        }
      );
    },
    GetSpeechDocumentTable() {
      let self = this;
      const { page, itemsPerPage } = self.options;
      self.sortBy =
        self.options.sortBy.length == 0 ? null : self.options.sortBy[0];
      self.sortDesc =
        self.options.sortDesc.length == 0 ? null : self.options.sortDesc[0];
      var tempData = {
        page: page,
        perPage: itemsPerPage,
        documentName: self.searchDocName,
        sortBy: self.sortBy,
        sortDesc: self.sortDesc,
      };
      self.$call.GetSpeechDocument(
        tempData,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.speechDocumentData.data = dataResponse.data.data;
          }
        },
        (errorResource) => {
          console.error(errorResource);
        }
      );
    },
    RefreshSpeechDocumentDetail() {
      let self = this;
      const { page, itemsPerPage } = self.options;
      self.sortBy =
        self.options.sortBy.length == 0 ? null : self.options.sortBy[0];
      self.sortDesc =
        self.options.sortDesc.length == 0 ? null : self.options.sortDesc[0];
      var tempData = {
        page: page,
        perPage: itemsPerPage,
        id: self.documentId,
        sortBy: self.sortBy,
        sortDesc: self.sortDesc,
      };
      self.$call.GetSpeechDocumentDetail(
        tempData,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.speechDocumentDataDetail.data = dataResponse.data.data;
            if (self.speechDocumentDataDetail.data != 0) {
              self.speechDocumentDataDetail.total = dataResponse.data.total;
              self.speechDocumentDataDetail.data.forEach((item) => {
                item.summarizedText =
                  item.summarizedText == null ? "-" : item.summarizedText;
              });
            }
          }
        },
        (errorResource) => {
          console.error(errorResource);
        }
      );
    },
    EditSpeechDocumentDetail(item) {
      let self = this;
      self.editDialog = true;
      self.edit = {
        id: item.id,
        originalText: item.originalText,
        summarizedText:
          item.summarizedText === "-" || item.summarizedText === " "
            ? null
            : item.summarizedText,
      };
    },
    EditSave() {
      let self = this;
      self.editDialog = false;
      // self.speechDocumentDataDetail.data.forEach((item) =>{
      //   if(item.id == self.edit.id){
      //     item.originalText = self.edit.originalText;
      //     item.summarizedText = self.edit.summarizedText ?? item.summarizedText;
      //   }
      // });
      self.$call.EditSpeechDocumentDetail(
        self.edit,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.$swal.fire({
              icon: "success",
              title: dataResponse.message,
              showConfirmButton: false,
              timer: 1500,
            });
          }
          self.GetSpeechDocumentDetail();
        },
        (errorResource) => {
          console.error(errorResource);
        }
      );
    },
    SummarizedPopup(item) {
      let self = this;
      self.SummarizedPreparePopup = true;
      self.SummarizedRow = {
        id: item.id,
        originalText: item.originalText,
        summarizedText: item.summarizedText,
        modelDisplayID: item.modelDisplayID,
      };
    },
    SummarizedDetail() {
      let self = this;
      self.loading = true;
      self.$call.SummarizedSpeechDocumentDetail(
        self.SummarizedRow,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.$swal.fire({
              icon: "success",
              title: dataResponse.message,
              showConfirmButton: false,
              timer: 1500,
            });
          }
          self.loading = false;
          self.SummarizedPreparePopup = false;
          self.GetSpeechDocumentDetail();
        },
        (errorResource) => {
          self.loading = false;
          self.SummarizedPreparePopup = false;
          console.error(errorResource);
        }
      );
    },
    DeleteById(id) {
      let self = this;
      try {
        self.$swal
          .fire({
            title: this.$t("confirmDeletion"),
            text: this.$t("confirmDeletionAllQuestion"),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: this.$t("confirm"),
            cancelButtonText: this.$t("cancel"),
            reverseButtons: false,
          })
          .then((result) => {
            if (result.isConfirmed) {
              self.$call.DeleteSpeechDocumentDetail(
                id,
                (dataResponse) => {
                  if (dataResponse.status == 0) {
                    self.$swal.fire({
                      icon: "success",
                      title: dataResponse.message,
                      showConfirmButton: false,
                      timer: 1500,
                    });
                    if (
                      self.speechDocumentDataDetail.data.length == 1 &&
                      self.options.page != 1
                    ) {
                      self.options.page -= 1; //ถ้าลบข้อมูลสุดท้ายของหน้านั้นๆให้บังคับกลับไปหน้าก่อน
                    }
                    if (self.speechDocumentDataDetail.data.length == 1) {
                      self.$router.push("/UploadSoundToDocument");
                    }
                    self.GetSpeechDocumentDetail();
                  }
                  self.loading = false;
                },
                (errorResource) => {
                  self.loading = false;
                  console.error(errorResource);
                }
              );
            }
          });
      } catch (error) {
        this.LogTrace(error, "DeleteGroup");
      }
    },
    Search() {
      let self = this;
      self.GetSpeechDocumentDetail();
    },
    getStyle(template) {
      return template == "-" ? { textAlign: "center" } : { textAlign: "left" }; //make "-" placeholder center when it's was used
    },
    getItemModelNameText(item) {
      if (this.modelDisplayID == 0) {
        this.modelDisplayID = 1;
      }
      return `${item.modelDisplayID}: ${item.name}`;
    },
    getItemModelNameID(item) {
      return item.modelDisplayID;
    },
    GetDDLVector() {
      let self = this;
      self.$call.GetDDLVector(
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.listDDLVector = dataResponse.data;
          } else {
            self.listDDLVector = [];
          }
        },
        (errorResource) => {
          console.error(errorResource);
        }
      );
    },
    getDocName(item) {
      if (this.DocId == 0) this.DocId = item.id;
      return item.id;
    },
    getDocId(item) {
      return item.id;
    },
    formatText(text) {
      return text.replace(/ /g, "&nbsp;");
    },

    async AutoRefresh() {
      let self = this;
      let death_waiting = true;
      do {
        for (let doc of self.speechDocumentData.data) {
          if (doc.documentName == self.documentId) {
            if (doc.inProcess < doc.processFinish) {
              self.RefreshSpeechDocumentDetail();
              death_waiting = true;
              break;
            } else {
              death_waiting = false;
            }
          }
        }
        for (let doc of self.speechDocumentDataDetail.data) {
          if (doc.inProcess == true) {
            self.RefreshSpeechDocumentDetail();
            death_waiting = true;
            break;
          } else {
            death_waiting = false;
          }
        }
        if (window.location.pathname != "/UploadSoundToDocumentDetail") {
          death_waiting = false;
        }
        await new Promise((resolve) => setTimeout(resolve, 5000));
      } while (death_waiting);
    },
    async GetModel() {
      let self = this;
      await self.$call.DDGPTModel(
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.listDDModelDisplayName = dataResponse.data;
          } else {
            self.listDDModelDisplayName = [];
          }
        },
        (errorResource) => {
          console.error(errorResource);
        }
      );
    },
    GetMaxLimitedCharacter() {
      let self = this;
      self.dialog = true;
      self.$call.GetMaxLimitedCharacter(
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.maxLimitedCharacter = dataResponse.data;
          } else {
            self.maxLimitedCharacter = null;
          }
          self.dialog = false;
        },
        (errorResource) => {
          self.dialog = false;
          console.error(errorResource);
        }
      );
    },
  },
  mounted() {
    this.GetDate();
    this.GetModel();
    this.GetDDLVector();
    this.GetMaxLimitedCharacter();
    this.GetSpeechDocumentDetail();
  },
};
</script>

<style scoped>
.card2 {
  border-radius: 10px !important;
  margin-bottom: 2rem;
  padding-top: 0 !important;
}

.card {
  border-radius: 10px !important;
  margin-bottom: 2rem;
  height: 90vh;
  overflow: auto;
  padding: 0;
}

.flex {
  margin-left: 2rem;
  margin-right: 2rem;
}

.v-overlay--active {
  z-index: 2000 !important;
}

.v-data-table th,
.v-data-table td {
  white-space: normal !important;
  word-break: break-word;
}

.text-container {
  display: flex;
  align-items: flex-start;
}

.text-content {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  white-space: normal;
  flex-grow: 1;
}

.text-content-show {
  overflow: hidden;
  -webkit-box-orient: vertical;
  white-space: normal;
  flex-grow: 1;
}

.responsive-table td {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  overflow-wrap: anywhere;
}

/* Header Section */
.header-section {
  background: white;
  border-radius: 16px 16px 0 0;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

/* Document Showcase */
.document-showcase {
  background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%);
  padding: 1.5rem 2rem;
  color: white;
}

.document-header {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.document-icon {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  padding: 0.75rem;
  backdrop-filter: blur(10px);
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.document-info {
  flex: 1;
}

.document-label {
  font-size: 0.875rem;
  opacity: 0.9;
  font-weight: 500;
  display: block;
  margin-bottom: 0.25rem;
}

.document-name {
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  word-break: break-word;
}

/* Controls Row */
.controls-row {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 2rem;
  padding: 1.25rem 2rem;
  background: #f8f9fa;
  border-top: 1px solid rgba(0, 0, 0, 0.05);
}

.toggle-section {
  display: flex;
  align-items: center;
}

.compact-toggle {
  background: rgba(255, 255, 255, 0.507);
  border-radius: 6px;
  padding: 0.25rem 0.75rem;
  border: 1px solid #e0e0e0a4;
  margin: 0;
  transform: scale(0.85);
}

.toggle-label {
  display: flex;
  align-items: center;
  font-weight: 500;
  font-size: 0.8rem;
  color: #424242;
}

.add-btn-green {
  border-radius: 10px !important;
  font-weight: 600;
  text-transform: none;
  height: 44px;
  min-width: 120px;
  background: linear-gradient(135deg, #4caf50 0%, #388e3c 100%) !important;
  box-shadow: 0 4px 12px rgba(76, 175, 80, 0.3);
  color: white !important;
}

.add-btn-green:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(76, 175, 80, 0.4);
  background: linear-gradient(135deg, #66bb6a 0%, #4caf50 100%) !important;
}

.add-btn-green:active {
  transform: translateY(0);
  box-shadow: 0 2px 8px rgba(76, 175, 80, 0.3);
}

.add-btn-green:disabled {
  opacity: 0.6;
  transform: none !important;
  box-shadow: none !important;
  background: #e0e0e0 !important;
}

/* Table Row Styling */
.table-row {
  transition: all 0.2s ease;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

.table-row:hover {
  background: rgba(25, 118, 210, 0.02);
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

/* Number Cell */
.number-cell {
  text-align: center;
  padding: 1rem 0.5rem;
  width: 80px;
}

/* Text Cells */
.text-cell {
  padding: 1rem;
  vertical-align: top;
  position: relative;
}

.text-container {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  min-height: 60px;
}

.text-content-wrapper {
  flex: 1;
  border-radius: 8px;
  padding: 0.75rem;
  transition: all 0.2s ease;
}

.text-content {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  white-space: normal;
  line-height: 1.5;
  color: #424242;
  font-size: 0.875rem;
}

.text-content-show {
  white-space: normal;
  line-height: 1.6;
  color: #424242;
  font-size: 0.875rem;
}

/* Expand Button */
.expand-btn {
  background: transparent !important;
  border-radius: 50% !important;
  width: 32px !important;
  height: 32px !important;
  align-self: flex-start;
  margin-top: 0.5rem;
}

.expand-btn:hover {
  background: rgba(25, 118, 210, 0.1) !important;
  transform: scale(1.1);
}

/* Action Cell */
.action-cell {
  text-align: center;
  padding: 1rem 0.5rem;
  vertical-align: middle;
  width: 160px;
}

.action-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.action-group {
  display: flex;
  align-items: center;
  background: rgba(0, 0, 0, 0.02);
  border-radius: 8px;
  padding: 4px 6px;
  border: 1px solid rgba(0, 0, 0, 0.06);
  transition: all 0.2s ease;
  gap: 8px;
}

.action-group:hover {
  background: rgba(0, 0, 0, 0.04);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.summarize-btn {
  border-radius: 10px !important;
  background: #ffe0b2 !important;
  color: #e77b00 !important;
}

.summarize-btn:hover {
  background: #ff9800 !important;
  color: white !important;
}

/* Action Divider */
.action-divider {
  width: 1px;
  height: 20px;
  background: rgba(0, 0, 0, 0.12);
  margin: 0 4px;
  align-self: center;
  border-radius: 1px;
  transition: background-color 0.2s ease;
}

.action-group:hover .action-divider {
  background: rgba(0, 0, 0, 0.2);
}

/* Table Improvements */
:deep(.v-data-table-server) {
  border-radius: 0 0 16px 16px;
  overflow: hidden;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
}

:deep(.v-data-table__wrapper) {
  border-radius: 0 0 16px 16px;
}

:deep(.v-data-table-header) {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-bottom: 2px solid #dee2e6;
}

:deep(.v-data-table-header th) {
  color: #495057 !important;
  font-weight: 700 !important;
  font-size: 0.875rem !important;
  padding: 1rem !important;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 2px solid rgba(25, 118, 210, 0.1) !important;
}

:deep(.v-data-table tbody tr:last-child td) {
  border-bottom: none;
}

/* Loading State */
:deep(.v-data-table--loading .v-data-table__wrapper) {
  opacity: 0.6;
}

/* Empty State */
:deep(.v-data-table-rows-no-data) {
  text-align: center;
  padding: 3rem;
  color: #757575;
  font-style: italic;
}

/* Custom Scrollbar */
:deep(.v-data-table__wrapper)::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

:deep(.v-data-table__wrapper)::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

:deep(.v-data-table__wrapper)::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

:deep(.v-data-table__wrapper)::-webkit-scrollbar-thumb:hover {
  background: #a1a1a1;
}

/* Dialog Styles - อิงจาก UploadSoundToDocument */
.upload-dialog,
.edit-dialog,
.import-dialog,
.summarize-dialog {
  border-radius: 16px !important;
  overflow: hidden;
}

/* .dialog-header {
  background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%);
  color: white;
  padding: 0;
} */

.header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.5rem 2rem;
  width: 100%;
}

.header-left {
  display: flex;
  align-items: center;
}

.header-icon-wrapper {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  padding: 0.75rem;
  margin-right: 1rem;
  backdrop-filter: blur(10px);
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px dashed rgba(255, 255, 255, 0.3);
}

.header-text .dialog-title {
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0 0 0.25rem 0;
  color: white;
}

.header-text .dialog-subtitle {
  font-size: 0.875rem;
  opacity: 0.9;
  margin: 0;
  color: rgba(255, 255, 255, 0.8);
}

/* .close-btn {
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
}

.close-btn:hover {
  background: rgba(255, 255, 255, 0.2);
} */

/* Dialog Content */
.dialog-content {
  padding: 2rem;
  background: #fafafa;
}

.input-group {
  margin-bottom: 1rem;
}

.input-label {
  display: block;
  font-size: 0.875rem;
  font-weight: 600;
  color: #424242;
  margin-bottom: 0.5rem;
}

.modern-input {
  background: white;
  border-radius: 12px;
}

.modern-input .v-field {
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.modern-input.input-disabled {
  opacity: 0.6;
}

/* Inline Switch Styles */
.inline-switch {
  margin: 15px 0 0 0;
  padding: 0.5rem 1rem;
  background: rgba(25, 118, 210, 0.05);
  border-radius: 8px;
  border: 1px solid rgba(25, 118, 210, 0.1);
  width: 100%;
}

.inline-label {
  display: flex;
  align-items: center;
  font-weight: 500;
  font-size: 1rem;
  color: #424242;
}

.inline-switch :deep(.v-switch__track),
.inline-switch :deep(.v-switch__thumb) {
  transform: scale(0.85);
}

/* Upload Section */
.upload-section {
  background: white;
  border-radius: 16px;
  padding: 1.5rem;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
}

.upload-header {
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
}

.upload-title {
  font-size: 1.1rem;
  font-weight: 600;
  color: #424242;
}

.upload-area-card {
  border-radius: 12px;
  border: none;
  transition: all 0.3s ease;
  background: #fafafa;
}

.upload-area-card :deep(.v-card) {
  width: 100% !important;
  border: none !important;
}

.upload-area-card :deep(.v-card .v-card-text .v-icon) {
  color: rgba(0, 0, 0, 0.377) !important;
}

.upload-area-card.drag-over {
  border-color: #1976d2;
  background: rgba(25, 118, 210, 0.05);
  transform: scale(1.02);
}

.upload-help-text {
  display: flex;
  align-items: center;
  margin-top: 0.75rem;
  font-size: 0.8rem;
  color: #757575;
}

/* Info Card */
.info-card {
  background: rgba(33, 150, 243, 0.05);
  border: 1px solid rgba(33, 150, 243, 0.2);
  border-radius: 12px;
  padding: 1rem;
  display: flex;
  align-items: flex-start;
  font-size: 0.875rem;
  color: #424242;
}

/* Dialog Actions */
/* .dialog-actions {
  background: white;
  padding: 1.5rem 2rem;
  border-top: 1px solid #e0e0e0;
}

.actions-left {
  display: flex;
  align-items: center;
}

.actions-right {
  display: flex;
  gap: 0.75rem;
  align-items: center;
}

.action-btn {
  border-radius: 10px !important;
  font-weight: 500;
  text-transform: none;
  height: 38px;
  width: 38px;
  transition: all 0.2s ease;
}

.delete-btn {
  height: 38px !important;
  width: 38px !important;
}
.cancel-btn {
  border-radius: 10px !important;
  border-color: #bdbdbd;
  color: #757575;
}

.cancel-btn:hover {
  background: rgba(189, 189, 189, 0.1);
  transform: scale(1.05);
} */
/* 
.upload-btn {
  border-radius: 10px; */
/* background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%); */
/* box-shadow: 0 4px 12px rgba(25, 118, 210, 0.3);
}

.upload-btn:hover {
  box-shadow: 0 6px 16px rgba(25, 118, 210, 0.4);
  transform: translateY(-1px);
} */

.import-btn {
  border-radius: 10px;
  background: linear-gradient(135deg, #4caf50 0%, #388e3c 100%);
  box-shadow: 0 4px 12px rgba(76, 175, 80, 0.3);
}

.import-btn:hover {
  box-shadow: 0 6px 16px rgba(76, 175, 80, 0.4);
  transform: translateY(-1px);
}

.padding-btn {
  padding: 0 1.5rem;
}

/* Edit Dialog Specific */
.edit-dialog .header-icon-wrapper {
  background: rgba(255, 152, 0, 0.2);
}

.edit-icon {
  background: rgba(255, 255, 255, 0.2) !important;
}

/* Import Dialog Specific */
.import-icon {
  background: rgba(255, 255, 255, 0.2) !important;
}

/* Summarize Dialog Specific */
.summarize-icon {
  background: rgba(255, 255, 255, 0.2) !important;
}

/* Save Button */
/* .save-btn {
  border-radius: 10px;
  background: linear-gradient(135deg, #4caf50 0%, #388e3c 100%);
  box-shadow: 0 4px 12px rgba(76, 175, 80, 0.3);
}

.save-btn:hover {
  box-shadow: 0 6px 16px rgba(76, 175, 80, 0.4);
  transform: translateY(-1px);
} */

/* Summarize Button */
.summarize-btn {
  background: linear-gradient(135deg, #ff9800 0%, #f57c00 100%);
}

.summarize-btn:hover {
  box-shadow: 0 6px 16px rgba(255, 152, 0, 0.4);
  transform: translateY(-1px);
}

/* Modern Textarea */
.modern-input .v-textarea :deep(.v-field__field) {
  min-height: 120px;
}

/* Disabled Input Style */
.modern-input:has(.v-field--disabled) {
  opacity: 0.7;
}

/* Transitions */
.v-dialog-transition-enter-active,
.v-dialog-transition-leave-active {
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.v-dialog-transition-enter-from {
  opacity: 0;
  transform: scale(0.9) translateY(20px);
}

.v-dialog-transition-leave-to {
  opacity: 0;
  transform: scale(0.9) translateY(-20px);
}

/* Responsive Design */
@media (max-width: 768px) {
  .document-showcase {
    padding: 1rem 1.5rem;
  }

  .document-header {
    flex-direction: column;
    text-align: center;
    gap: 0.75rem;
  }

  .document-name {
    font-size: 1.25rem;
  }

  .controls-row {
    flex-direction: column;
    gap: 1rem;
    padding: 1rem 1.5rem;
  }

  .toggle-section {
    width: 100%;
    justify-content: center;
  }

  .add-btn-green {
    width: 100%;
    max-width: 200px;
  }

  .action-group {
    flex-direction: column;
    gap: 2px;
    padding: 6px 4px;
  }

  .action-divider {
    width: 80%;
    height: 1px;
    margin: 2px 0;
  }

  .action-btn {
    width: 32px !important;
    height: 32px !important;
  }

  .text-container {
    flex-direction: column;
    gap: 0.5rem;
  }

  .expand-btn {
    align-self: center;
    margin-top: 0;
  }

  .header-content {
    padding: 1rem;
  }

  .dialog-content {
    padding: 1rem;
  }

  .dialog-actions {
    padding: 1rem;
    flex-direction: column;
    gap: 1rem;
  }

  .actions-left,
  .actions-right {
    width: 100%;
    justify-content: center;
  }
}

@media (max-width: 480px) {
  .document-showcase {
    padding: 0.75rem 1rem;
  }

  .document-name {
    font-size: 1.1rem;
  }

  .controls-row {
    padding: 0.75rem 1rem;
  }

  .text-cell {
    padding: 0.5rem;
  }

  .text-content-wrapper {
    padding: 0.5rem;
  }

  .action-cell {
    padding: 0.5rem 0.25rem;
    width: 120px;
  }
}
</style>
